import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import ErrorMessage, { ErrorProps } from '../ErrorMessage';

const ErrorComponent = (props: ErrorProps) => (
  <ErrorMessage
    {...props}
    localizedRetryText={<FormattedMessage id="common.error.button.retry" />}
    localizedHeaderText={<FormattedMessage id="common.error.header.title" />}
    localizedReloadText={<FormattedMessage id="common.error.button.reload" />}
  />
);

export default ErrorComponent;
